// src/pages/ProductDetails/BackupChart.jsx
import React, { useState } from "react";

import "./InverterShared.css";
import "./BackupChart.css";

const LOAD_SCENARIOS = [
  {
    id: "light",
    label: "Basic Load",
    icon: "💡",
    time: "8 - 10",
    unit: "Hours",
    appliances: [
      { name: "4x LED Bulbs", icon: "💡" },
      { name: "2x Ceiling Fans", icon: "🌀" },
      { name: "1x Wi-Fi Router", icon: "📡" },
    ],
  },
  {
    id: "medium",
    label: "Entertainment",
    icon: "📺",
    time: "4 - 6",
    unit: "Hours",
    appliances: [
      { name: "3x LED Bulbs", icon: "💡" },
      { name: "2x Ceiling Fans", icon: "🌀" },
      { name: "1x Smart TV", icon: "📺" },
      { name: "1x Laptop/PC", icon: "💻" },
    ],
  },
  {
    id: "heavy",
    label: "Heavy Duty",
    icon: "❄️",
    time: "2 - 3",
    unit: "Hours",
    appliances: [
      { name: "2x LED Bulbs", icon: "💡" },
      { name: "1x Ceiling Fan", icon: "🌀" },
      { name: "1x Refrigerator", icon: "🧊" },
      { name: "1x Desktop", icon: "🖥️" },
    ],
  },
];

const BackupChart = ({ capacityVa }) => {
  const [active, setActive] = useState(LOAD_SCENARIOS[0]);

  return (
    <section className="apple-section">
      <h2 className="apple-title">Estimated Backup Time</h2>
      <p className="apple-subtitle">
        Based on a standard 100Ah Lithium Battery setup.
      </p>

      <div className="backup-chart-wrapper">
        <div className="load-selectors">
          {LOAD_SCENARIOS.map((scenario) => (
            <button
              key={scenario.id}
              className={`load-btn ${active.id === scenario.id ? "active" : ""}`}
              onClick={() => setActive(scenario)}
            >
              {scenario.icon} {scenario.label}
            </button>
          ))}
        </div>

        <div className="chart-display">
          <div className="time-readout">
            <div className="time-value">{active.time}</div>
            <div className="time-label">{active.unit} of Backup</div>
          </div>

          <div className="appliances-visual">
            {active.appliances.map((app, idx) => (
              <div
                key={`${active.id}-${idx}`}
                className="appliance-item"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div style={{ fontSize: "2rem", marginBottom: "8px" }}>
                  {app.icon}
                </div>
                <div
                  style={{
                    fontSize: "0.9rem",
                    color: "#1d1d1f",
                    fontWeight: "500",
                  }}
                >
                  {app.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BackupChart;
